<template>
  <div id="app">
    <loading
      :active.sync="this.isLoading"
      :is-full-page="fullPage"
      color="rgb(0, 128,255)"
    ></loading>
    <b-col v-if="isLoggedIn">
      <b-row>
        <b-col align-self="end" style="text-align: right">
          {{ getUsername }}
          <input type="hidden" id="ithUserID" value="0"/>
          <b-button @click="logout" class="logOutBtn" size="sm">Sair</b-button>
        </b-col>
      </b-row>
      <b-row class="navBar" v-if="isNotInConfig()">
        <b-col>
          <img src="./assets/logo.png" style="height: 50px" />
        </b-col>
        <b-col
          class="text-center navbar1"
          @click="$router.push({ name: 'Home' })"
        >
          <a>Dashboard</a>
        </b-col>
        <b-col class="navbar2" @click="$router.push({ name: 'NewsEdition' })">
          <a>Noticias</a>
        </b-col>
        <b-col class="navbar3">
          <div class="dropdown">
            <span>Configurações</span>
            <div class="dropdown-content">
              <a @click="$router.push({ name: 'SourceMain' })">Fonte</a>
              <a @click="$router.push({ name: 'ThemeWords' })">Theme Words</a>
            </div>
          </div>
        </b-col>
        <b-col class="navbar4" @click="$router.push({ name: 'OperationLog' })">
          <a>Relatorio Logs/Erros</a>
        </b-col>
      </b-row>
    </b-col>
    <router-view></router-view>
  </div>
</template>

<script>
import { EventBus } from "./event-bus";
import Vue from "vue";
import { mapGetters } from "vuex";
import router from "./router/index";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "app",
  data() {
    return {
      fullPage: true,
    };
  },

  methods: {
    logout: function () {
      this.$api.logout();
    },
    isNotInConfig() {
      if (this.$router.history.current["path"] != "/NewsEdition") {
        document.body.style = "overflow-y:scroll";
        return true;
      } else {
        document.body.style = "overflow-y: hidden";
        return false;
      }
    },
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters({
      getUsername: "auth/getUsername",
      isLoggedIn: "auth/isLoggedIn",
      isLoading: "api/isLoading",
      getUserId: "auth/getUserId",
    }),
  },
  async mounted() {
    EventBus.$on("api_error", (err) => {
      this.$bvToast.toast(`${err}`, {
        autoHideDelay: 4000,
        variant: "danger",
      });
    });
    EventBus.$on("api_success", (res) => {
      this.$bvToast.toast(`${res}`, {
        autoHideDelay: 4000,
        variant: "success",
      });
    });
  },
};
</script>

<style>
/* body::-webkit-scrollbar {
  display: none;
} */

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.logOutBtn {
  margin-left: 10px;
  margin-right: 10px;
  color: black;
  background-color: white;
  border: 2px solid;
}

.navbar1 {
  background-color: rgb(66, 139, 172);
  margin: 5px;
  color: white;
  padding: 10px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.navbar2 {
  background-color: rgb(44, 99, 112);
  padding: 10px;
  margin: 5px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.navbar3 {
  background-color: rgb(70, 135, 151);
  padding: 10px;
  margin: 5px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}
.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: rgb(70, 135, 151);
  min-width: 160px;
  padding: 12px 16px;
  z-index: 2;
  width: 100%;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.navbar4 {
  background-color: rgb(58, 115, 101);
  padding: 10px;
  margin: 5px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue